const ProfilePage = () => {
  return <h1>Profilo</h1>;
};

export default ProfilePage;
